import { Link } from "react-router-dom";

export function Logo({ light = false, className = "h-11 sm:h-12" }) {
  return (
    <Link to="/" data-testid="logo-link" className="inline-flex items-center">
      <img src="/krvprime-logo.png" alt="KRV Prime" className={`${className} w-auto object-contain`} />
    </Link>
  );
}
